// extracted by mini-css-extract-plugin
export default {"captions":"Field_captions__BFDGo","field":"Field_field__YgGxp","extraSpace":"Field_extraSpace__gRBEP","description":"Field_description__dRvGF"};